import Helpers from './Helpers';
import LoggedInUser from './LoggedInUser';

export const fetchCharges = async (page) => {
  const { auth_token } = LoggedInUser.getInfo()
  const response = await fetch(Helpers.endpoint(`/charges/?page=${page}&auth_token=${auth_token}`), {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  })
  return response.json()
}
